const moduleName = '.user'

export default ({
  clientWrapper,
  context
}) => ({
  recoverPassword: (email) => {
    context.lastApiPath = `${moduleName}.recoverPassword`

    return clientWrapper.api.post("/user/recover", {
      email
    })
  },

  updatePassword: (passw, repeatPassw) => {
    context.lastApiPath = `${moduleName}.updatePassword`
    
    return clientWrapper.api.post("/user/update_password", {
      password: passw,
      confirmed_password: repeatPassw
    })
  }
})